module.exports = __webpack_public_path__ + "media/stop.3a68028d.mp3";